module.exports = __webpack_public_path__ + "img/content3.d2f800cf.png";